import { cn } from "@babybjorn/ui";
import type { FC, PropsWithChildren } from "react";
import * as s from "./MoreSalesList.module.scss";

type Props = PropsWithChildren<{
	paddedItems?: boolean;
	heading?: string;
	headingType?: "paragraph" | "heading";
}>;

const MoreSalesList: FC<React.HTMLAttributes<HTMLElement> & Props> = ({
	children,
	paddedItems,
	heading,
	headingType,
	className,
	...props
}) => {
	return (
		<article className={cn(s.container, className)} {...props}>
			{heading && headingType !== "paragraph" && (
				<h4 className={s.heading}>{heading}</h4>
			)}
			{heading && headingType === "paragraph" && (
				<p className={s.label}>{heading}</p>
			)}
			<ul className={cn(s.list, { [s.paddedItemsList]: paddedItems })}>
				{children}
			</ul>
		</article>
	);
};

export default MoreSalesList;
